var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-template',{staticClass:"text-16 uppercase"},[(_vm.doc)?_c('div',{staticClass:"children-mt-em",domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }